import React from 'react';

import HomepageSectionPressBar from '@gik/homepage/components/SectionPressbar/HomepageSectionPressBar';

export default function HomepagePressBarContainer({ className }: { className?: string }): JSX.Element {
  return (
    <div className={`homepage-press-bar-container ${className}`}>
      <div className="homepage-press-bar-content">
        <HomepageSectionPressBar />
      </div>
    </div>
  );
}
